"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFieldRow = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const Radio_1 = __importDefault(require("@material-ui/core/Radio/Radio"));
const OpenInNew_1 = __importDefault(require("@material-ui/icons/OpenInNew"));
const tooltip_1 = require("../tooltip/tooltip");
const table_field_styles_1 = require("./table-field-styles");
const table_field_context_1 = require("./table-field-context");
const text_cell_1 = require("./cells/text-cell");
const table_field_drag_handle_1 = require("./table-field-drag-handle");
const clsx_1 = __importDefault(require("clsx"));
exports.TableFieldRow = react_1.memo(react_1.forwardRef(function TableFieldRow({ index, value, selected }, ref) {
    const classes = table_field_styles_1.useStyles();
    const { disabled, selectRow, showDetailDialog, filteredColumns, showDetailBtnCond, showRadioCond, useDnDOrdering, onSelect, visibleActionsColumn, } = react_1.useContext(table_field_context_1.TableFieldContext);
    const handleSelectClick = event_callback_hook_1.useEventCallback(() => {
        if (showRadioCond(value) && !disabled) {
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(value, index);
            selectRow(index);
        }
    });
    const handleDetailClick = event_callback_hook_1.useEventCallback(() => {
        showDetailDialog(index);
    });
    return (react_1.default.createElement("div", { className: clsx_1.default(classes.row, {
            [classes.defaultCursor]: !showRadioCond(value) && !showDetailBtnCond(value),
        }), onClick: handleSelectClick, ref: ref },
        visibleActionsColumn && (react_1.default.createElement("div", { className: classes.tableRowActions },
            !disabled && useDnDOrdering && (react_1.default.createElement(table_field_drag_handle_1.DragHandle, { className: classes.rowDraggable })),
            !disabled && showRadioCond(value) && (react_1.default.createElement(Radio_1.default, { className: classes.radioButton, checked: selected, onChange: handleSelectClick, color: "primary" })),
            disabled && showDetailBtnCond(value) && (react_1.default.createElement(tooltip_1.Tooltip, { title: "Otev\u0159e kr\u00E1tk\u00FD detail", placement: "top-start" },
                react_1.default.createElement(OpenInNew_1.default, { onClick: handleDetailClick }))))),
        filteredColumns.map((column, i) => {
            const { CellComponent = text_cell_1.TextCell } = column;
            return (react_1.default.createElement("div", { key: i, className: classes.cellWrapper, style: {
                    width: column.width,
                } },
                react_1.default.createElement(CellComponent, { index: index, value: lodash_1.get(value, column.datakey, ''), rowValue: value, column: column })));
        })));
}));
//# sourceMappingURL=table-field-row.js.map